import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
  SimpleLoading,
  InstructionsPure,
  DialogDescriptionHLPure,
  ButtonTemplatePure,
  ButtonHLPure,
} from "../../pures";
import './dialog-pdf.css'

const DialogPdfHLPure = (props) => {
  const {
    loadingComponent,
    cancel,
    saveError,
    title,
    description,
    handleSubmitProfile,
    saveBtn,
    canelBtn,
    profiles,
    userId,
    userName,
    children,
    width,
    height,
    heightBody,
    showExtraBtn,
    extrabtnlabel,
    handleExtraBtn,
    classNameDescription,
    disableSubmit,
  } = props;


  return (
    <Dialog
      width={width}
      height={height}
      title={title}
      onClose={cancel}
    >
      {loadingComponent && (
        <div>
          <SimpleLoading />
        </div>
      )}

      {!saveError && !loadingComponent && (
        <form>
          <div className="dialogPdfHLPure-body-dialog">
            {
              description && (
                <div className={(classNameDescription) ? classNameDescription : "dialogPdfHLPure-description-container"}>
                  <InstructionsPure instructions={[description]} />
                </div>
              )
            }
            <div className="dialogPdfHLPure-container-children" style={{ height: `${heightBody}px` }}>
              {children}
            </div>
            <div
              item="true"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="dialogPdfHLPure-btns-container"
            >
              <div className="dialogPdfHLPure-btn-cancel">
                <ButtonHLPure
                  nameBtn={canelBtn}
                  primary={false}
                  onClickBtn={cancel}
                />
              </div>

              {
                showExtraBtn && (
                  <div className="dialogPdfHLPure-btn-cancel">
                    <ButtonHLPure
                      nameBtn={extrabtnlabel}
                      primary={false}
                      onClickBtn={(e) => handleExtraBtn(e)}
                    />
                  </div>
                )
              }

              {
                handleSubmitProfile ? (
                  <ButtonHLPure
                    disabled={disableSubmit}
                    nameBtn={saveBtn}
                    primary={true}
                    onClickBtn={(e) => handleSubmitProfile(e)}
                  />
                )
                  : null
              }
            </div>
          </div>
        </form>
      )}
    </Dialog>
  );
};

export { DialogPdfHLPure as default };
